$('.form.add-to-cart-form').each(function(_, element){
    var $el = $(element);
    var form = $el.find('form');
    var button = $el.find('.add-to-cart');

    button.on('click', function() {
        form.submit();
    });

    form.on('submit', function(ev){
        ev.preventDefault();

        var url = form.attr('action');
        var data = form.serializeArray();
        Belimo.Cart.submit(url, data);

        return false;
    });
});
